import { render } from "./VpcTiersTab.vue?vue&type=template&id=bc04aa0c&scoped=true"
import script from "./VpcTiersTab.vue?vue&type=script&lang=js"
export * from "./VpcTiersTab.vue?vue&type=script&lang=js"

import "./VpcTiersTab.vue?vue&type=style&index=0&id=bc04aa0c&lang=scss&scoped=true"

import exportComponent from "/jenkins/workspace/acs-deb-pkg-builder/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bc04aa0c"]])

export default __exports__